/* eslint-disable react-refresh/only-export-components */
import { ReactNode } from 'react';

import { GenericIconProps } from 'ui/components/icon/Icon';
import {
  ClientBooking,
  ClientPublicBooking,
} from 'modules/account/calendar/containers';
import CardPublic from 'modules/account/card/containers';
import VerifyEmail from 'pages/private/containers/verify/VerifyEmail';
import VerifyLink from 'pages/private/containers/verify/VerifyLink';

import _PublicRoutes from './PublicRoutes';
import Register from './containers/register';
import AdminLogin from './containers/login/AdminLogin';
import ForgotPassword from './containers/forgot-password';
import ChangePassword from './containers/change-password';
import Invited from './containers/invited';
import { Login } from './containers/login';
export interface ROUTE {
  index?: boolean;
  path: string;
  to?: string;
  iconLeft?:
    | React.FC<GenericIconProps>
    | React.LazyExoticComponent<React.FC<GenericIconProps>>;
  element?: () => ReactNode;
  development?: boolean;
  acl?: string[];
  label?: string;
  hidden?: boolean;
  disabled?: boolean;
  subMenu?: ROUTE[];
  atFooter?: boolean;
  childPath?: string;
  isCommon?: boolean;
  key?: string;
  isSubscribe?: boolean;
  isLocked?: boolean;
}

const Routes: ROUTE[] = [
  {
    index: true,
    path: '/',
    element: () => <Login />,
  },
  {
    path: '/p/*',
    element: () => <_PublicRoutes />,
  },
  {
    path: '/register',
    element: () => <Register />,
  },
  {
    path: '/invite/*',
    element: () => <Invited />,
  },
  {
    path: '/login',
    to: '/login/*',
    element: () => <Login />,
  },
  {
    path: '/admin/login',
    to: '/admin/login/*',
    element: () => <AdminLogin />,
  },
  {
    path: '/forgot-password',
    element: () => <ForgotPassword />,
  },
  {
    path: '/change-password',
    element: () => <ChangePassword />,
  },
];

export const PublicRoutes: ROUTE[] = [
  {
    path: '/cb/:id',
    element: () => <ClientBooking />,
  },
  {
    path: '/cpb/:id',
    element: () => <ClientPublicBooking />,
  },
  {
    path: '/c/:id/*',
    element: () => <CardPublic />,
  },
  {
    path: 'verify/link',
    element: () => <VerifyLink />,
  },
];

export const VerifyRoutes: ROUTE[] = [
  {
    path: '/email',
    element: () => <VerifyEmail />,
  },
];

export default Routes;
